import type { QueryClient } from "@tanstack/react-query";
import type { NotificationTypeEnum } from "web_myplann/Infrastructure/Api/Api";

export const NotificationsKeys = {
	all: ["notifications"] as const,
	count: () => [...NotificationsKeys.all, "count"] as const,
	countFiltered: (
		unreadOnly?: boolean,
		excludeTypes?: NotificationTypeEnum[],
	) => [...NotificationsKeys.count(), unreadOnly, excludeTypes] as const,
	infiniteGroupedList: (unreadOnly?: boolean) =>
		[
			...NotificationsKeys.all,
			"grouped",
			"list",
			"infinite",
			{ unreadOnly },
		] as const,
	infiniteGroupedListFiltered: (
		unreadOnly?: boolean,
		excludeTypes?: NotificationTypeEnum[],
	) =>
		[
			...NotificationsKeys.infiniteGroupedList(unreadOnly),
			excludeTypes,
		] as const,
	groupedCountAll: () =>
		[...NotificationsKeys.all, "grouped", "count"] as const,
	groupedCount: (unreadOnly?: boolean) =>
		[...NotificationsKeys.groupedCountAll(), unreadOnly] as const,
	groupedCountFiltered: (
		unreadOnly?: boolean,
		excludeTypes?: NotificationTypeEnum[],
	) => [...NotificationsKeys.groupedCount(unreadOnly), excludeTypes] as const,
};

export const invalidateNotifications = (queryClient: QueryClient) =>
	queryClient.invalidateQueries({ queryKey: NotificationsKeys.all });
